import { http } from 'common/helpers/axios/axios-helper';
import { 
  APIClientsModel as Model, 
  APIClientsQuery as Query,
  APIClientsListModel } from '../model/api-clients.model';
const basePath = '/clientapi';

async function getDataList(query?: Query & { orderBy?: string; order?: 'asc' | 'desc' }) {
  const queryString = query ? `?pageNumber=${query.pageNumber}&pageSize=${query.pageSize}&orderBy=${query.orderBy}&order=${query.order}` : '';
  const response = await http.get<APIClientsListModel>(`${basePath}${queryString}`);
  
  if (response) {
    return response;
  } else {
    return { data: {items: [], totalCount: 0, pageNumber: query?.pageNumber, pageSize: query?.pageSize}, total: 0, hasErrors: true }; 
  }
}



async function getRandomSecret() {
  return await http.get<any>(`${basePath}/guid`);
}

async function getDataById(id: any) {
  return await http.get<Model>(`${basePath}/${id}`);
}

async function postData(data: Model) {
  return await http.post<Model>(`${basePath}`, data);
}

async function putData(data: Model) {
  return await http.put<Model>(`${basePath}/${data.id}`, data);
}

async function deleteDataById(id: any) {
  return await http.del(`${basePath}/${id}`);
}

export const APIClientsService = {
  getDataList,
  getRandomSecret,
  getDataById,
  postData,
  putData,
  deleteDataById
};
